import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { UnUploadedImage } from "components/PhotoUpload/types";

import { createDerivedSessionAtom } from "../utils/createDerivedSessionAtom";
import { createPersistedAtom } from "../utils/createPersistedAtom";

const sessionVehiclePhotos = atomFamily((sessionId: string) =>
  createPersistedAtom<UnUploadedImage[]>(`vinPhotos-${sessionId}`, [])
);
export const sessionVin = atomFamily((sessionId: string) => createPersistedAtom<string>(`vin-${sessionId}`, ""));

export const vinPhotoAtom = createDerivedSessionAtom<UnUploadedImage[]>(sessionVehiclePhotos);
export const vinUploadedAtom = atom((get) => get(vinPhotoAtom).length > 0);

export const vinAtom = createDerivedSessionAtom<string>(sessionVin);
export const vinInputAtom = atom((get) => get(vinAtom).length > 0);

const sessionVinErrorAtom = atomFamily((sessionId: string) => createPersistedAtom(`vinError-${sessionId}`, ""));

export const vinErrorAtom = createDerivedSessionAtom<string>(sessionVinErrorAtom);
